import React from "react";

import { PreviewLayout } from "./";
import { QRProps } from "@/contexts/QREditorContext/types";

export default function PreviewWifi(props: QRProps<"wifi">) {
  const { qrNetworkName } = props?.data;
  const isInitPreview = props?.initPreview;
  return (
    <PreviewLayout
      page="wifi"
      dataQA="preview-wifi-container"
      includeBrowser
      initPreview={isInitPreview}>
      <div className="qr-wifi-container">
        <img
          // src={`/images/phone-previews/phone-wifi-empty.png`}
          src="https://res.cloudinary.com/dqemqumik/image/upload/f_auto,q_auto/v1693375570/assets/phone-wifi-empty_csyzoa.png"
          alt={"wifi"}
          className="default-preview"
        />
        <div className="qr-wifi-networkName">
          {qrNetworkName ? `"${qrNetworkName}"?` : `"Central Cafe"?`}
        </div>
      </div>
    </PreviewLayout>
  );
}
